import React, { useEffect, useState } from "react";
import { Card, CardBody, Avatar, Box, Icon, Progress } from "@chakra-ui/react";
import { FaStar } from "react-icons/fa";
import TitleBox from "../TitleBox";
import ParrotText from "../ParrotText";

interface LoadingProps {
  onLoadingComplete: () => void;
}

const testimonials = [
  {
    name: "Susan R.",
    image: "https://i.pravatar.cc/300?img=21",
    text: "After a year on Duolingo, I still couldn't understand Netflix shows. With Parrot, I'm finally starting to catch more and more of what native speakers say. It's making such a difference!",
  },
  {
    name: "Stephanie B.",
    image: "https://i.pravatar.cc/300?img=10",
    text: "Duolingo taught me phrases, but Parrot is teaching me how people actually speak. I'm gradually understanding more of real conversations and different accents. It feels like real progress!",
  },
  {
    name: "Michael A.",
    image: "https://i.pravatar.cc/300?img=7",
    text: "Traditional apps didn't prepare me for real conversations. With Parrot's natural speech patterns, I'm finally understanding native speakers. It's the real-world practice I needed!",
  },
];

const PlanLoading: React.FC<LoadingProps> = ({ onLoadingComplete }) => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [opacity, setOpacity] = useState(1);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const loadingTimer = setTimeout(() => {
      onLoadingComplete();
    }, 9000);

    const testimonialTimer = setInterval(() => {
      setOpacity(0);

      setTimeout(() => {
        setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
        setOpacity(1);
      }, 500);
    }, 5000);

    const progressInterval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) return 100;
        return Math.min(prev + 0.25, 100);
      });
    }, 30);

    return () => {
      clearTimeout(loadingTimer);
      clearInterval(testimonialTimer);
      clearInterval(progressInterval);
    };
  }, [onLoadingComplete]);

  return (
    <div className="flex flex-col items-center justify-center w-full h-full gap-11 p-2 pb-12 pt-16">
      <div className="flex flex-col items-center gap-14">
        <ParrotText />
        <TitleBox
          title={
            <span className="flex text-center items-center justify-center self-center">
              Building your personalized learning plan
            </span>
          }
          subtitle={
            <span className="text-center items-center justify-center">
              Use Parrot and stop speaking in 'Duolingo'
            </span>
          }
          classname="text-center items-center justify-center"
        />
        <Progress
          value={progress}
          width="300px"
          sx={{
            "& > div": {
              background: "var(--color-blue)",
            },
          }}
          borderRadius="full"
          size="sm"
        />
      </div>

      <div className="flex items-end pt-8">
        <Card
          maxW="sm"
          className="w-[340px] shadow-[0_4px_12px_rgba(0,0,0,0.1)]"
          style={{
            opacity: opacity,
            transition: "opacity 1000ms ease-in-out",
          }}
        >
          <CardBody className="flex flex-col items-center text-center gap-2">
            <Avatar
              name={testimonials[currentTestimonial].name}
              src={testimonials[currentTestimonial].image}
              size="lg"
            />
            <Box className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Icon key={i} as={FaStar} color="var(--color-yellow)" />
              ))}
            </Box>
            <Box>
              <p className="font-medium text-lg">
                {testimonials[currentTestimonial].name}
              </p>
              <p className="text-[var(--color-grey)] mt-2">
                "{testimonials[currentTestimonial].text}"
              </p>
            </Box>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default PlanLoading;
